import { CONSTANT } from "./constant"
import { Context } from "@/types/systemContext"

export const SHOW_HOC_MEMBERSHIP_FEATURES_EXTENSION = "eecom_show_hoc_membership_features"

export const membershipChildRouteNames = [CONSTANT.ROUTE.NAME.MEMBERSHIP, CONSTANT.ROUTE.NAME.MEMBERSHIP_INVITATION]

export const salesForceMembershipChildRouteNames = [CONSTANT.ROUTE.NAME.SALES_FORCE_MEMBERSHIP, CONSTANT.ROUTE.NAME.SALES_FORCE_MEMBERSHIP_INVITATION]

export const membershipRouteNames = [...membershipChildRouteNames, ...salesForceMembershipChildRouteNames]

export const isMembershipRoute = (routeName?: string | null): boolean => {
  return routeName != null && membershipRouteNames.includes(routeName)
}

export const isMembershipFeaturesEnabled = (context?: Context | null): boolean => {
  return context?.extensions?.[SHOW_HOC_MEMBERSHIP_FEATURES_EXTENSION]?.showHocMembershipFeatures === true
}
